"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalSpacingTokens = exports.SIZE_TO_REM_MAP = void 0;
__exportStar(require("./colors"), exports);
exports.SIZE_TO_REM_MAP = {
    '0': '0rem',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '8': '2rem',
    '10': '2.5rem',
    '12': '3rem',
    '16': '4rem',
    '20': '5rem',
    '24': '6rem',
    '32': '8rem',
    '40': '10rem',
    '48': '12rem',
    '56': '14rem',
    '64': '16rem',
};
var generateSpacingObj = function () {
    var result = {};
    for (var key in exports.SIZE_TO_REM_MAP) {
        var unitSize = key;
        // *** padding ***********************************
        //  same as <div className="p5"> ===> padding: 5px
        result[("p" + unitSize)] = { padding: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="pt5"> ===> paddingTop: 5px
        result[("pt" + unitSize)] = { paddingTop: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="pb5"> ===> paddingBottom: 5px
        result[("pb" + unitSize)] =
            { paddingBottom: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="pl10"> ===> paddingLeft: 10px
        result[("pl" + unitSize)] = { paddingLeft: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="pr5"> ===> paddingRight: 5px
        result[("pr" + unitSize)] = { paddingRight: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="px30"> ===> paddingLeft: 30px, paddingRight: 30px
        result[("px" + unitSize)] = {
            paddingLeft: exports.SIZE_TO_REM_MAP[unitSize],
            paddingRight: exports.SIZE_TO_REM_MAP[unitSize],
        };
        //  same as <div className="py5"> ===> paddingleft: 5px, paddingRight: 5px
        result[("py" + unitSize)] = {
            paddingTop: exports.SIZE_TO_REM_MAP[unitSize],
            paddingBottom: exports.SIZE_TO_REM_MAP[unitSize],
        };
        // *** margins ***********************************
        //  same as <div className="p5"> ===> padding: 5px
        result[("m" + unitSize)] = { margin: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="pt5"> ===> paddingTop: 5px
        result[("mt" + unitSize)] = { marginTop: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="pb5"> ===> paddingBottom: 5px
        result[("mb" + unitSize)] = { marginBottom: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="pl10"> ===> paddingLeft: 10px
        result[("ml" + unitSize)] = { marginLeft: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="pr5"> ===> paddingRight: 5px
        result[("mr" + unitSize)] = { marginRight: exports.SIZE_TO_REM_MAP[unitSize] };
        //  same as <div className="mx5"> ===> marginLeft: 5px, marginRight: 5px
        result[("mx" + unitSize)] = {
            marginLeft: exports.SIZE_TO_REM_MAP[unitSize],
            marginRight: exports.SIZE_TO_REM_MAP[unitSize],
        };
        //  same as <div className="my5"> ===> marginleft: 5px, marginRight: 5px
        result[("my" + unitSize)] = {
            marginTop: exports.SIZE_TO_REM_MAP[unitSize],
            marginBottom: exports.SIZE_TO_REM_MAP[unitSize],
        };
    }
    return result;
};
var generateCSSClassNames = function (spacingVariables) {
    if (spacingVariables === void 0) { spacingVariables = {}; }
    var spacingNamesCSS = {};
    for (var key in spacingVariables) {
        var keyAsShortHandName = key;
        var newDotNotationKey = "." + keyAsShortHandName;
        spacingNamesCSS[newDotNotationKey] =
            spacingVariables[keyAsShortHandName];
    }
    return spacingNamesCSS;
};
/**
 * Global spacing to be used to apply padding and margins
 *
 * <div className="px10"></div>
 * -- style applied to the above div is
 * -- paddingLe ft: 10px, paddingRight: 10px
 *
 * <div className="mx10"></div>
 * -- style applied to the above div is
 * -- marginLeft: 10px, marginRight: 10px
 *
 * Levels available = '0'| '1'| '2'| '3'| '4'| '5'| '10'| '15'|
 *  '20'| '25'| '30'| '35'| '40'| '45'| '50'| '55'| '60'| '65'| '70'| '75';
 */
exports.GlobalSpacingTokens = {
    cssSpacingObj: generateCSSClassNames(generateSpacingObj()),
    emotionSpacingObj: generateSpacingObj(),
};
